<template>
<div class="date-box" :class="colourClass">
    <div @click="menuVisible = !menuVisible">
    {{value}}
        <v-menu :value="menuVisible" left :nudge-bottom="7" :nudge-right="9" offset-y class="button">
        <template v-slot:activator="{ on }">
        <v-btn small v-on="on" icon>
            <v-icon class="button" >keyboard_arrow_down</v-icon>
        </v-btn>      
        </template>      
       <v-list>
            <v-list-item v-for="(item, index) in optionsList" :key="index" @click="selectItem(item)">
                <v-list-item-action>
                    <v-icon :class="textColourClass(item.colour)">label</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title> {{ item.label }}</v-list-item-title>
                 </v-list-item-content>
            </v-list-item>
        </v-list>
        </v-menu>
 
    </div>
</div>    
</template>

<script>

// 
import StringHelpers from '../helpers/StringHelpers'


export default {
    data() {
        return {
            menuVisible: false,
        }
    },
    
    props: {
        label: String,
        value: String,
        options: {
            type: String,
            default: 'One|red,Two|blue,Three|orange'
        }
    },

    computed: {
        // longFormat() {
        //     return StringHelpers.formatCurrency(this.value)
        // },
        // shortFormat() {
        //     return StringHelpers.formatInteger(this.value)
        // },

        colourClass() {
            return this.currentColour + ' lighten-2'
        },

        optionsList() {
            let items = []
            let optionsArr = this.options.split(',')
            optionsArr.forEach(item => {
                let itemArr = item.split('|')
                let label = itemArr[0]
                let colour = itemArr[1] || 'grey'
                items.push( {label: label, colour: colour} )
            })
            return items
        },

        currentColour() {
            let currentItem = this.optionsList.find(o => o.label == this.value)
            return currentItem ? currentItem.colour : 'grey'
        }
    },

    methods: {

        textColourClass(colour) {
            return colour + '--text text--lighten-2'
        },

        // emitInput(val) {
        //     this.$emit('input', val)
        // },
        // changed(val) {
        //     val = this.formatValue(val)
            
        //     this.$emit('input', val)
        //     this.$emit('change')

        //     //this.editing = false

        //     return true
        // },

        selectItem(item) {
            this.$emit('input', item.label)
        }       

    }


}
</script>

<style scoped>
    .date-box {
        border: solid 2px grey;
        padding:2px; border-radius: 5px;
    }   
    .date-box > div {
        background-color: transparent;
        border: solid 2px white;
        color: white; font-weight: bold;
        padding:5px 8px; border-radius: 3px;
    }   
    .date-box .button {
        float:right;
        top: -10px; right: -10px;
        color:white;
    } 
</style>




// WEBPACK FOOTER //
// StatusBox.vue?ab6cc2ba